
export const mockActivities = [
  {
    id: '1',
    name: '双十一大促',
    status: 'active',
    type: 'promotion',
    startDate: '2025-10-31',
    endDate: '2025-11-11',
    budget: 20000000,
    spent: 320000,
    targetKPI: {
      newMembers: 10000,
      conversionRate: 15,
      revenue: 2000000
    },
    currentKPI: {
      newMembers: 6800,
      conversionRate: 12.5,
      revenue: 1350000
    },
    businessLines: ['PV：1000 万', 'UV：300 万', '活动范围：全国'],
    progress: 68
  },
  {
    id: '2',
    name: '新品发布会',
    status: 'planning',
    type: 'launch',
    startDate: '2025-12-15',
    endDate: '2025-12-20',
    budget: 200000,
    spent: 45000,
    targetKPI: {
      newMembers: 3000,
      conversionRate: 20,
      revenue: 800000
    },
    currentKPI: {
      newMembers: 0,
      conversionRate: 0,
      revenue: 0
    },
    businessLines: ['PV：1000 万', 'UV：300 万', '活动范围：全国'],
    progress: 25
  },
  {
    id: '3',
    name: '会员专享日',
    status: 'completed',
    type: 'member',
    startDate: '2025-10-20',
    endDate: '2025-10-22',
    budget: 150000,
    spent: 142000,
    targetKPI: {
      newMembers: 2000,
      conversionRate: 25,
      revenue: 600000
    },
    currentKPI: {
      newMembers: 2100,
      conversionRate: 28,
      revenue: 650000
    },
    businessLines: ['PV：1000 万', 'UV：300 万', '活动范围：全国'],
    progress: 100
  },
  {
    id: '4',
    name: '春节营销活动',
    status: 'draft',
    type: 'seasonal',
    startDate: '2025-01-25',
    endDate: '2025-02-15',
    budget: 800000,
    spent: 0,
    targetKPI: {
      newMembers: 15000,
      conversionRate: 18,
      revenue: 3000000
    },
    currentKPI: {
      newMembers: 0,
      conversionRate: 0,
      revenue: 0
    },
    businessLines: ['PV：1000 万', 'UV：300 万', '活动范围：全国'],
    progress: 5
  }
];

export const mockCalendarEvents = [
  {
    id: '1',
    title: '双十一大促',
    start: '2024-11-01',
    end: '2024-11-11',
    type: 'promotion',
    status: 'active',
    progress: 68,
    budget: 500000,
    spent: 320000
  },
  {
    id: '2',
    title: '新品发布会',
    start: '2024-12-15',
    end: '2024-12-20',
    type: 'launch',
    status: 'planning',
    progress: 25,
    budget: 200000,
    spent: 45000
  },
  {
    id: '3',
    title: '会员专享日',
    start: '2024-10-20',
    end: '2024-10-22',
    type: 'member',
    status: 'completed',
    progress: 100,
    budget: 150000,
    spent: 142000
  },
  {
    id: '4',
    title: '春节营销活动',
    start: '2025-01-25',
    end: '2025-02-15',
    type: 'seasonal',
    status: 'draft',
    progress: 5,
    budget: 800000,
    spent: 0
  },
  {
    id: '5',
    title: '元旦促销',
    start: '2024-12-30',
    end: '2025-01-03',
    type: 'promotion',
    status: 'planning',
    progress: 15,
    budget: 100000,
    spent: 8000
  }
];

export const mockDashboardData = {
  totalActivities: 12,
  activeActivities: 3,
  totalBudget: 2500000,
  totalSpent: 1250000,
  totalRevenue: 5600000,
  newMembers: 28900,
  avgConversionRate: 16.8,
  riskAlerts: [
    {
      id: '1',
      type: 'budget',
      message: '双十一活动预算使用率已达64%，请关注支出控制',
      severity: 'warning',
      activityId: '1'
    },
    {
      id: '2',
      type: 'schedule',
      message: '新品发布会筹备进度滞后，建议加快执行',
      severity: 'error',
      activityId: '2'
    }
  ]
};
